import FeesCard from "./FeesCard";

export default function Class5() {
  return (
    <FeesCard
        badge="Class 5"
        title="💰 Class 5 Tuition Details"
        className="5th Standard"
        fee="₹1,200"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "English",
          "Mathematics",
          "Science",
          "Social Studies"
        ]}
        approach={[
          "Exam-oriented preparation",
          "Regular tests",
          "Strong foundation"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}